/*
 *
 * Application Main
 *
 */
!(function(APP) {
    'use strict';


    var breakpoint = 768;

    $.extend(true, APP, {
        breakpoint: breakpoint,
        init: {
            aside: () => {
                $('.aside-menu > li a').on('click', function(e) {

                    var $this = $(this);

                    if ( $this.next().is('ul') ) {

                        e.preventDefault();
                        $this.next().collapse('toggle');
                        $this.parent().toggleClass('collapsed').find('ul > li').removeClass('active');
                    }
                });

                $('.aside-container select').on('change', function() {
                    location.href = APP.sanitizeXss($(this).val());
                });
            },
            shareButton: function () {
                let shareButton = $('.share-icon button');
                let socialMediaIcons = $('.social-icons');
                shareButton.on('click', function () {
                    $(this).parent().toggleClass('active');
                    socialMediaIcons.toggleClass('d-none');
                });
            },
            dynamicTable: () => {
                $('.dynatable').dynatable({
                    features: {
                        recordCount: false
                    },
                    dataset: {
                        perPageDefault: 10,
                        perPageOptions: [10, 25, 50, 100]
                    },
                    inputs: {
                        paginationPrev: 'Önceki Sayfa',
                        paginationNext: 'Sonraki Sayfa',
                        perPageText: 'Gösterilen Sonuç Sayisi: ',
                        processingText: 'İşleniyor...',
                        searchText: 'Arama: '
                    }
                });
            },
            subMenu: () => {
                // Menü açıldıktan sonra ekranın blurlaşma özelliği
                function backgroundOverlay() {
                    let navbar = $('#navbarMain');
                    let overlay = $('#overlay');

                    navbar.on('show.bs.collapse', function () {
                        overlay.addClass('active');
                    });

                    navbar.on('hidden.bs.collapse', function () {
                        overlay.removeClass('active');
                    });
                }

                $('#closeMenu').click(function() {
                    $('.navbar-collapse').collapse('hide');
                });

                backgroundOverlay();
            },
            showMore: () => {
                let showMoreBtn = $('.show-more-link');

                showMoreBtn.click(function(e) {
                    e.preventDefault();

                    var hiddenListItems = $(this).parent().prevAll('.hidden');
                    hiddenListItems.removeClass('hidden');

                    $(this).hide();
                });

            },
            asd: () => {

                if ($('.banner, .hero').length > 0) {
                    $('#header').addClass('header-sticky');
                }
            },
            scrollToFix: () => {

                var header = $('#header');

                $(window).on('scroll', APP.Helper.throttle(scroll, 150, true));

                function scroll() {
                    if (window.scrollY > 105) {
                        header.addClass('compress');
                    } else {
                        header.removeClass('compress');
                    }
                }

                scroll();
            }
        },

        INIT: function(options) {
            // APP init

            options = options || {};

            var fn;

            for (var i in this.init) {
                if ( Object.prototype.hasOwnProperty.call(this.init, i) && i.charAt(0) !== '_' && typeof(fn = this.init[i]) === 'function' ) {
                    fn.call(this, options && options[i] || options);
                }
            }

            return this;
        }
    });

})(window.APP = window.APP || {});

$(function() {
    'use strict';

    APP.browser = (function() {

        var is = APP.Helper.is,
            val, tmp,
            userAgent = APP.sanitizeXss(navigator.userAgent);

        var browser = {
            mobile: !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile/i.test(userAgent),
            ios: !!/iPhone|iPad|iPod/i.test(userAgent),
            ie: (tmp = userAgent.toLowerCase().match(/MSIE ([^;]+)|rv:(11)\.[0-9]+/i)) ? parseInt(tmp[1] || tmp[2], 10) : false,
            edge: (tmp = userAgent.indexOf('Edge/')) > 0 ? parseInt(userAgent.substring(tmp + 5, userAgent.indexOf('.', tmp)), 10) : false,
            bp: function() {
                return $(window).width() < APP.breakpoint;
            }
        };

        var $el = $('html'); // document.documentElement

        for (var k in browser ) {
            if ( Object.prototype.hasOwnProperty.call(browser, k) ) {
                val = browser[k];

                if ( val && !is.function(val) ) {
                    $el.addClass(k);
                    if ( !is.boolean(val) ) {
                        $el.addClass(k + val);
                    }
                }
            }
        }

        APP.browser = browser;

        return browser;
    }());

    APP.scriptPath = APP.Helper.getScriptPath(['app.js', 'app.min.js', 'main.js']);

    APP.Helper.loadScript(APP.scriptPath + 'config.js', {
        success: function() {
            APP.INIT(CONFIG);
        },
        failed: function() {
            APP.INIT();
        }
    });
});
